import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Contact = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the external contact page
    window.location.href = "https://mystep-ai.info/contact";
  }, []);

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <Button
            variant="ghost"
            onClick={() => navigate(-1)}
            className="mb-4"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back
          </Button>
          <h1 className="text-3xl font-bold mb-4">Contact Us</h1>
          <p className="text-muted-foreground">
            You are being redirected to our contact page...
          </p>
          <p className="mt-4">
            If you are not redirected automatically,{" "}
            <a
              href="https://mystep-ai.info/contact"
              className="text-primary underline"
            >
              click here
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;